var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-banner"},[_c('img',{staticClass:"component-banner",attrs:{"src":_vm.data.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }